export default class EasingFunctions {
    static easeOutExp(progress) {
        return progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
    }
    static easeInExp(progress) {
        return progress === 0 ? 0 : Math.pow(2, 10 * progress - 10);
    }
    static linear(progress) {
        return progress;
    }
}
//# sourceMappingURL=EasingFunctions.js.map